import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Typography,
  Button,
  Box,
  TextField,
  Grid2,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { Search, BorderColor } from "@mui/icons-material";
import { getCareTeamById, getCareTeamUserList, resetState } from "../../redux/reducers/careTeamReducer"
import CustomGenericTable from "../../components/CustomGenericTable";
import GenericModal from "../../components/Modal";
import CareTeamForm from "./CareTeamForm";
import Loader from "../../components/Loader";
import withToast from "../../hocs/withToast";
import './styles.css';

const columns = [
  { id: "careUserName", label: "Name" },
  { id: "email", label: "Email" },
  { id: "phone", label: "Phone" },
];


const CareTeamManagement = () => {
  const dispatch = useDispatch();
  const { careTeamList = [], loading, rowCount } = useSelector((state) => state.careTeam);
  const [showCareTeamAddEditModal, setShowCareTeamAddEditModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredCareTeam, setFilteredCareTeam] = useState(careTeamList || []);

  useEffect(() => {
    dispatch(getCareTeamUserList())
  }, [])

  const handleCareTeamModal = (show) => {
    setShowCareTeamAddEditModal(show);
  };

  const startEdit = (id) => {
    if (!id) {
      dispatch(resetState());
      handleCareTeamModal(true, false);
    } else {
      const editEntity = careTeamList.find(ele => ele.careUserId === id);
      const updatedEntity = editEntity ? { id, firstName: editEntity?.careUserFirstName, lastName: editEntity?.careUserLastName, ...editEntity } : null;
      dispatch(getCareTeamById(updatedEntity))
      handleCareTeamModal(true, false);
    }
  };

  useEffect(() => {
    let filteredList = careTeamList;
    if (searchQuery) {
      filteredList = filteredList.filter((careTeamUser) =>
        careTeamUser.careUserFirstName.toLowerCase().includes(searchQuery?.toLowerCase()) ||
        careTeamUser.careUserLastName.toLowerCase().includes(searchQuery?.toLowerCase())

      );
    }
    setFilteredCareTeam(filteredList);
  }, [searchQuery, careTeamList]);

  const rowsWithAction = (rows) => {
    return rows?.length && rows.map((e) => ({
      ...e,
      careUserName: (
        <div className="rowHeading" onClick={() => startEdit(e.careUserId)}>
          <strong>
            {`${e.careUserFirstName} ${e.careUserLastName}`}
          </strong>
        </div>
      )
    }));
  };

  return (
    <>
      {/* Header Section */}
      <Grid2
        container
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
        sx={{ mb: 2 }}
      >
        <Grid2
          item
          xs={12}
          md={6}
          sx={{ display: "flex", alignItems: "center", gap: 1 }}
        >
          <Typography variant="h4" fontWeight="bold">
            Care Team Management
          </Typography>
        </Grid2>

        <Grid2
          item
          xs={12}
          sm
          sx={{
            display: "flex",
            alignItems: "center",
            flexWrap: { xs: "wrap", sm: "nowrap" },
            gap: { xs: 1, sm: 1.5 },
            mt: { xs: 2, sm: 0 },
          }}
        >
          <Button
            variant="outlined"
            sx={{
              fontSize: "0.75rem",
              bgcolor: "#000",
              color: "#fff",
              border: "none",
              borderRadius: "50px",
              boxShadow: "0px 2px 4px rgba(0, 0, 0, 4)",
              fontWeight: "500",
              minWidth: "110px",
              height: "38px",
              "&:hover": { bgcolor: "#000" },
            }}
            onClick={() => startEdit(0)}
          >
            Add Care Team Member
          </Button>
        </Grid2>
      </Grid2>

      {/* Device Table Section */}
      <Box
        sx={{
          bgcolor: "#f5f5f5",
          mt: 3,
          border: "1px solid #ddd",
          borderRadius: "10px"
        }}
      >
        {/* Search and Tabs for filtering */}
        <Grid2
          container
          spacing={2}
          alignItems="center"
          sx={{ my: 0, borderRadius: "10px", p: 2, bgcolor: "white", marginBottom: '10px' }}
        >
          {/* Search field */}
          <Grid2
            item
            xs={12}
            md={6}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <TextField
              fullWidth
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search by Name"
              variant="outlined"
              size="small"
              sx={{
                width: { xs: "100%", md: "600px" },
                maxWidth: "750px",
                flexGrow: 1,
                borderRadius: "50px",
                "& .MuiOutlinedInput-root": {
                  borderRadius: "50px",
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <IconButton edge="start">
                      <Search sx={{ color: "#c1c5cd" }} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid2>
        </Grid2>

        {/* Displaying the device tables */}
        <CustomGenericTable
          columns={columns}
          rows={rowsWithAction(filteredCareTeam) || []}
          rowCount={rowCount}
        />

        {showCareTeamAddEditModal && (
          <GenericModal
            modalShow={showCareTeamAddEditModal}
            modalClose={() => handleCareTeamModal(false, false)}
            modalHeader={"Care Team Member"}
            modalBody={
              <CareTeamForm
                modalClose={() => handleCareTeamModal(false, true)}
              />
            }
            size="lg"
          />
        )}
      </Box>
      <Loader loading={loading} />
    </>
  );
};

export default withToast(CareTeamManagement);